import { useQuery } from "react-query";

import { useUser } from "@/providers/context";
import { getNotificationPreferences } from "@/api";

export const useNotificationPreferences = () => {
  const { uid } = useUser();
  return useQuery(["notificationPreferences", uid], () => {
    if (uid) {
      return getNotificationPreferences({ user_id: uid });
    }
  });
};
